import { t } from "i18next";
import * as Yup from 'yup';

export function getOrganisationContactValidationScheme() {
    return Yup.object().shape({
        name: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
        phone: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
        email: Yup.string().required(t('Required')).email().max(100, t("Max characters exceeded", { max: 100 })),
    })
}
